export default {
	messages: {
		de: {
			itemsPerPage: 'Einträge pro Seite',
			of: 'von',
		},
		en: {
			itemsPerPage: 'Rows per Page',
			of: 'of',
		},
	},
};
